import { useLocation } from 'react-router-dom';

export const usePreserveQueryParams = () => {
	const location = useLocation();
	const queryString = location.search;

	const withQuery = (path) => {
		if (!queryString) return path;

		const hasExistingQuery = path.includes('?');
		const separator = hasExistingQuery ? '&' : '?';

		return `${path}${separator}${queryString.slice(1)}`;
	};

	return { withQuery };
};
